var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 20,
    viewBox: "0 0 170 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4089_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2564 8.96284C40.559 7.17141 42.2761 4.90227 43.8102 2.89913H48.5471C47.0399 4.6797 45.6027 6.30827 44.0309 8.11056L48.8162 17.1057H43.9502L41.1242 10.738C40.6182 11.2808 39.7355 12.3177 39.2564 12.8171V17.1057H34.9556V2.83398H39.2564V8.96284Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1559 9.87582C63.1559 15.0275 60.6744 17.3672 56.099 17.3672C51.5237 17.3672 49.1606 15.1361 49.1606 9.95182C49.1606 4.76753 51.9328 2.65039 56.3251 2.65039C60.7175 2.65039 63.1559 5.12039 63.1559 9.87582ZM53.4992 9.93011C53.4992 12.9755 54.1666 14.6312 56.2175 14.6312C58.1553 14.6312 58.812 12.9972 58.812 9.97353C58.812 6.94982 58.1284 5.41353 56.1852 5.41353C54.242 5.41353 53.4938 6.88468 53.4938 9.93011H53.4992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0841 7.31333C66.0841 4.39276 66.0841 3.63819 66.0464 2.89448H70.1804C70.2503 3.24733 70.3149 3.84448 70.3149 4.37105C70.8694 3.58933 72.0105 2.62305 74.4274 2.62305C77.4687 2.62305 79.1965 4.08876 79.1965 6.96048V17.101H74.8957V7.71505C74.8957 6.30362 74.5243 5.44048 72.791 5.44048C71.1654 5.44048 70.3849 6.14076 70.3849 8.2959V17.101H66.0787V7.31333H66.0841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3773 12.2863C95.302 13.4318 94.9682 17.3458 88.8211 17.3458C83.4814 17.3458 82.1572 14.0886 82.1572 9.87605C82.1572 6.11405 83.7828 2.62891 89.0418 2.62891C95.1566 2.62891 95.345 6.65148 95.3773 7.50919H91.0388C91.0011 6.95548 90.9258 5.33776 89.0095 5.33776C87.0932 5.33776 86.4957 6.95005 86.4957 9.89233C86.4957 12.8346 87.0878 14.626 88.9557 14.626C90.9688 14.626 91.1142 13.0843 91.2272 12.2809H95.3773V12.2863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.804 12.9265C110.804 14.9948 110.804 16.3682 110.842 17.0957H106.74C106.638 16.6614 106.6 16.0262 106.568 15.5431C105.744 16.8514 104.404 17.34 102.423 17.34C99.7695 17.34 97.7671 16.3465 97.7671 13.084V2.89453H102.073V12.3511C102.073 13.7517 102.455 14.5334 104.016 14.5334C105.578 14.5334 106.503 13.8657 106.503 11.6128V2.89453H110.81V12.9265H110.804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.562 7.71025C114.562 5.37596 114.562 3.91025 114.524 2.89511H118.626C118.663 3.13939 118.728 3.73111 118.728 5.23482C119.428 3.62796 121.075 2.66168 123.61 2.65625V6.33139C120.569 6.27711 118.857 6.96111 118.857 9.64825V17.1017H114.556V7.71025H114.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.041 10.8475C129.041 12.6498 129.332 14.653 131.711 14.653C133.853 14.653 134.128 13.2632 134.203 12.7855H138.316C138.246 13.2307 137.831 17.3672 131.646 17.3672C125.461 17.3672 124.767 13.4967 124.767 9.90296C124.767 5.39725 127.012 2.65039 131.732 2.65039C137.137 2.65039 138.461 5.73382 138.461 9.44153C138.461 9.93553 138.429 10.6032 138.391 10.8475H129.036H129.041ZM134.225 8.47525C134.225 7.09096 134.015 5.33753 131.732 5.33753C129.267 5.33753 129.116 7.44925 129.111 8.47525H134.225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.373 7.31333C141.373 4.39276 141.373 3.63819 141.335 2.89448H145.469C145.539 3.24733 145.604 3.84448 145.604 4.37105C146.158 3.58933 147.3 2.62305 149.716 2.62305C152.758 2.62305 154.486 4.08876 154.486 6.96048V17.101H150.185V7.71505C150.185 6.30362 149.813 5.44048 148.08 5.44048C146.454 5.44048 145.674 6.14076 145.674 8.2959V17.101H141.368V7.31333H141.373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.778 6.16888H156.816V2.80859H169.1V6.17431H165.138V17.0966H160.773V6.16888H160.778Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1753 3.9301L14.5281 16.0684C10.518 20.6392 4.01017 20.6392 0 16.0684L10.6471 3.9301C14.6573 -0.640761 21.1651 -0.640761 25.1753 3.9301Z",
    fill: "url(#paint0_linear_4089_3059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2841 4.0878C7.56819 2.05208 5.64115 0.591797 3.375 0.591797H0V13.5335L8.2841 4.0878Z",
    fill: "url(#paint1_linear_4089_3059)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1597 11.0371L15.7715 17.1823C14.9587 18.1051 14.049 18.8814 13.0586 19.5003H25.3259V18.9031C25.3259 15.6243 23.6734 12.7363 21.1651 11.0425L21.1597 11.0371Z",
    fill: "url(#paint2_linear_4089_3059)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4089_3059",
    x1: -1.79785,
    y1: 9.99924,
    x2: 24.201,
    y2: 9.99924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4089_3059",
    x1: -1.79785,
    y1: 7.06265,
    x2: 24.201,
    y2: 7.06265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4089_3059",
    x1: -1.79788,
    y1: 15.266,
    x2: 24.2009,
    y2: 15.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4089_3059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169.1,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1ab248dc75f46dc6f826ddceb0a4c0f1.svg";
export { ForwardRef as ReactComponent };